module.exports = __webpack_public_path__ + "img/22.e42de8da.jpg";